export class ResponseObject {
    //Data: object[];
    Data: any;
    Success: boolean;
    ErrorMessages: Array<string>;
};